/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  Bill,
  BillFileLinkResponse,
  BillSummary,
  Error,
  GetFinalBillResponse,
  GetUnbilledV2Params,
  Unbilled,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get an account's file bill by id and account id
 */
export const getBillFileByIdAndAccountIdV2 = (
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  billId = toValue(billId)

  return customInstance<BillFileLinkResponse>(
    {
      url: `/api/v2/accounts/${accountId}/bills/${billId}/download`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetBillFileByIdAndAccountIdV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
) => {
  return [
    "api",
    "v2",
    "accounts",
    accountId,
    "bills",
    billId,
    "download",
  ] as const
}

export const useGetBillFileByIdAndAccountIdV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetBillFileByIdAndAccountIdV2QueryKey(accountId, billId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>
  > = ({ signal }) =>
    getBillFileByIdAndAccountIdV2(accountId, billId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () =>
          toValue(accountId) !== null &&
          toValue(accountId) !== undefined &&
          toValue(billId) !== null &&
          toValue(billId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, billId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>,
    TError,
    TData
  >
}

export type GetBillFileByIdAndAccountIdV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>
>
export type GetBillFileByIdAndAccountIdV2QueryError = ErrorType<Error>

/**
 * @summary Get an account's file bill by id and account id
 */

export function useGetBillFileByIdAndAccountIdV2<
  TData = Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillFileByIdAndAccountIdV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetBillFileByIdAndAccountIdV2QueryOptions(
    accountId,
    billId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Get an account's bill by id and account id
 */
export const getBillByIdAndAccountIdV2 = (
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  billId = toValue(billId)

  return customInstance<Bill>(
    {
      url: `/api/v2/accounts/${accountId}/bills/${billId}`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetBillByIdAndAccountIdV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v2", "accounts", accountId, "bills", billId] as const
}

export const useGetBillByIdAndAccountIdV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetBillByIdAndAccountIdV2QueryKey(accountId, billId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>
  > = ({ signal }) =>
    getBillByIdAndAccountIdV2(accountId, billId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () =>
          toValue(accountId) !== null &&
          toValue(accountId) !== undefined &&
          toValue(billId) !== null &&
          toValue(billId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, billId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>,
    TError,
    TData
  >
}

export type GetBillByIdAndAccountIdV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>
>
export type GetBillByIdAndAccountIdV2QueryError = ErrorType<Error>

/**
 * @summary Get an account's bill by id and account id
 */

export function useGetBillByIdAndAccountIdV2<
  TData = Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  billId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillByIdAndAccountIdV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetBillByIdAndAccountIdV2QueryOptions(
    accountId,
    billId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary The account's latest final bill: accepted, not superseded and not deleted. finalBill is absent when the account has no final bill yet.
 */
export const getFinalBill = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<GetFinalBillResponse>(
    { url: `/api/v1/accounts/${accountId}/bills/final`, method: "GET", signal },
    options,
  )
}

export const getGetFinalBillQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "bills", "final"] as const
}

export const useGetFinalBillQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinalBill>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinalBill>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetFinalBillQueryKey(accountId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinalBill>>> = ({
    signal,
  }) => getFinalBill(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getFinalBill>>,
    TError,
    TData
  >
}

export type GetFinalBillQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinalBill>>
>
export type GetFinalBillQueryError = ErrorType<Error>

/**
 * @summary The account's latest final bill: accepted, not superseded and not deleted. finalBill is absent when the account has no final bill yet.
 */

export function useGetFinalBill<
  TData = Awaited<ReturnType<typeof getFinalBill>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinalBill>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetFinalBillQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Get bills summary for an account
 */
export const getBillsSummaryByAccountIdV2 = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<BillSummary[]>(
    { url: `/api/v2/accounts/${accountId}/bills`, method: "GET", signal },
    options,
  )
}

export const getGetBillsSummaryByAccountIdV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v2", "accounts", accountId, "bills"] as const
}

export const useGetBillsSummaryByAccountIdV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetBillsSummaryByAccountIdV2QueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>
  > = ({ signal }) =>
    getBillsSummaryByAccountIdV2(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>,
    TError,
    TData
  >
}

export type GetBillsSummaryByAccountIdV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>
>
export type GetBillsSummaryByAccountIdV2QueryError = ErrorType<Error>

/**
 * @summary Get bills summary for an account
 */

export function useGetBillsSummaryByAccountIdV2<
  TData = Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillsSummaryByAccountIdV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetBillsSummaryByAccountIdV2QueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Retrieve details about current charges present in the next bill, excluding standing charges unless requested.
 */
export const getUnbilledV2 = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetUnbilledV2Params>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  params = toValue(params)

  return customInstance<Unbilled>(
    {
      url: `/api/v2/accounts/${accountId}/unbilled`,
      method: "GET",
      params,
      signal,
    },
    options,
  )
}

export const getGetUnbilledV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetUnbilledV2Params>,
) => {
  return [
    "api",
    "v2",
    "accounts",
    accountId,
    "unbilled",
    ...(params ? [params] : []),
  ] as const
}

export const useGetUnbilledV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getUnbilledV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetUnbilledV2Params>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnbilledV2>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetUnbilledV2QueryKey(accountId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnbilledV2>>> = ({
    signal,
  }) => getUnbilledV2(accountId, params, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, params },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getUnbilledV2>>,
    TError,
    TData
  >
}

export type GetUnbilledV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnbilledV2>>
>
export type GetUnbilledV2QueryError = ErrorType<Error>

/**
 * @summary Retrieve details about current charges present in the next bill, excluding standing charges unless requested.
 */

export function useGetUnbilledV2<
  TData = Awaited<ReturnType<typeof getUnbilledV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetUnbilledV2Params>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnbilledV2>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetUnbilledV2QueryOptions(accountId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
